import React, { CSSProperties, ElementType, HTMLAttributes, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Content.module.scss';

type ContentProps = Partial<{
  center: boolean;
  children: ReactNode;
  className: string;
  element: ElementType;
  ref?: React.RefObject<HTMLDivElement | null> | ((ref: HTMLDivElement | null) => void);
  style: CSSProperties;
  wrapper: HTMLAttributes<HTMLDivElement>;
  wrapperContentPost: ReactNode;
  wrapperContentPre: ReactNode;
}>

const ContentBase = ({
  center,
  children,
  className,
  element,
  ref,
  wrapper,
  wrapperContentPost,
  wrapperContentPre,
  ...p
}: ContentProps) => {
  const ContainerElement = element || 'div';

  let content = (
    <ContainerElement
      ref={ref}
      className={cx(
        styles.content,
        className,
        {
          [styles.center]: center,
        },
      )}
      {...p}
    >
      {children}
    </ContainerElement>
  );

  if (wrapper) {
    content = (
      <div {...wrapper}>
        {wrapperContentPre}
        {content}
        {wrapperContentPost}
      </div>
    );
  }

  return content;
};

export const Content = (
  {
    ...props
  }: ContentProps,
) => (<ContentBase {...props} />);
